import { selectProfile, selectUpdatingProfileInfo } from '../../../../../store/workspace/selectors';
import { setEditAccountInfoModal } from '../../../../../store/workspace/slice';
import { updateProfileInfoThunk } from '../../../../../store/workspace/thunks';
import { useDispatch, useSelector } from '../../../../../store/store';
import { EditSquareIcon } from '../../../../../assets/icons';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Input';
import { useState } from 'react';

export default function EditAccountInfo() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const isLoading = useSelector(selectUpdatingProfileInfo);
    const [lastName, setLastName] = useState(profile?.lastName || '');
    const [firstName, setFirstName] = useState(profile?.firstName || '');

    const closeModal = () => dispatch(setEditAccountInfoModal(false));

    const submit = () => {
        dispatch(updateProfileInfoThunk({
            ...profile,
            lastName,
            firstName,
        }));
    };

    return (
        <Modal
            size='sm'
            actions='both'
            closeFunc={closeModal}
            icon={<EditSquareIcon />}
            childClassName={styles.wrapper}
            title='Edit account information'
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Primary',
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'Confirm',
                type: 'Primary',
                onClick: submit,
                disabled: !profile,
                loading: isLoading,
            }}
        >
            <Input
                type='text'
                label='First name'
                value={firstName}
                onChange={setFirstName}
            />
            <Input
                type='text'
                label='Last name'
                value={lastName}
                onChange={setLastName}
            />
        </Modal>
    );
};
